/**
 * Funkce vrátí array s počty pokojů pro použití v React Select
 * @param {number} max Max. počet pokojů, který chceme vygenerovat
 * @param {string} roomType
 * @returns {Array}
 */
export function getNumberOfRoomsOptions(max, roomType) {
	let options = [];

	if (max < 1) max = 1;

	// Pro různé hotely můžeme změnit label
	function getRoomLabelSuffix() {
		const hotelId = new URLSearchParams(window.location.search).get('hotelId');

		// chalupavapenka
		if (hotelId === 'wlm910' && roomType !== null)
			return '|' + roomType;

		// sandamiano
		if (hotelId === SANDAMIANO_HOTEL_ID)
			return '|bed';

		// Hotely, pro které se má zobrazit `chalupa` místo `pokoj`
		const cottageHotelIds = [
			'rmnwms', // chalupaustodoly
			'exetj1', // vestonickachalupa
		];

		if (cottageHotelIds.includes(hotelId))
			return '|cottage';

		return '';
	}

	for (let value = 1; value <= max; value++) {
		options.push({
			value,
			label: [['utils.getNumberOfRoomsOptions.room' + getRoomLabelSuffix(), { count: value }]]
		});
	}

	return options;
}

/**
 * Funkce nalezne podle klíče (value) textový popisek (label) v seznamu hodnot pro select (options).
 * @param {Array} options
 * @param {string} value
 * @returns {(string|null)}
 */
export function getLabelForSelectedValue(options, value) {
	for (let option of options) {
		if (option.value === value) {
			return option.label;
		}
	}
	return null;
}

/**
 * Cena bez symbolu měny.
 */
export function formatPriceNumber(price, currency) {
	return price.toLocaleString(currency.d_sep === ',' ? 'cs' : 'en-US', {
		minimumFractionDigits: currency.round,
		maximumFractionDigits: currency.round,
	});
}

export function formatPrice(price, currency) {
	let formattedPrice = '';
	if (currency.position === 'before') {
		formattedPrice += currency.symbol;
	}

	formattedPrice += formatPriceNumber(price, currency);

	if (currency.position === 'after') {
		formattedPrice += ' ' + currency.symbol;
	}
	return formattedPrice;
}

/**
 * Funkce převede JSON objekt na URL encoded form data, která se dají zaslat
 * jako application/x-www-form-urlencoded.
 * @param element
 * @param key
 * @param list
 * @returns {string}
 */
export function jsonToUrlEncoded(element, key, list){
	list = list || [];

	if (typeof element === 'object') {
		for (let idx in element) {
			if (!element.hasOwnProperty(idx)) continue;
			jsonToUrlEncoded(element[idx], key ? key + '[' + idx + ']' : idx, list);
		}

	} else {
		list.push(key + '=' + encodeURIComponent(element));
	}

	return list.join('&');
}

/**
 * Odeslat zprávu parentovi, pokud je aplikace umístěna v iframu
 * @param type
 * @param value
 */
export function postMessageToParent(type, value) {
	window.parent.postMessage({ type, value }, '*');
}

/**
 * Vrací, zda je aplikace zobrazena v iframu.
 * @returns {boolean}
 */
export function inIframe() {
	return window.self !== window.top;
}

/**
 * Vypočítá o kolik procent nová hodnota klesla či stoupla vůči staré.
 * @param newValue
 * @param original
 * @param decimals
 * @returns {number}
 */
export function calculatePercentage(newValue, original, decimals = 0) {
	const percentage = ((newValue - original) / original) * 100;
	const factor = 10 ** decimals;
	return Math.trunc(percentage * factor) / factor;
}

export function getTerms(app) {
	const lang = app.lang;

	return app.terms[lang] || app.terms['cs'];
}

export const FARMAOVCITERASYKARAVANY_HOTEL_ID = 'clt0x1'; // farmaovciterasykaravany
export const SANDAMIANO_HOTEL_ID = 'xa2r05'; // sandamiano

const EVENT_PACKAGE_HOTEL_IDS = [
	SANDAMIANO_HOTEL_ID,
];

/**
 * Vrací, zda je pro daný hotel zapnutá funkcionalita předvyplněných balíčků/událostí.
 *
 * @param {string} hotelId
 * @returns {boolean}
 */
export function isEventPackageFeatureEnabled(hotelId) {
	return EVENT_PACKAGE_HOTEL_IDS.includes(hotelId);
}



// WEBPACK FOOTER //
// ./src/utils.js